import useSound from 'use-sound';
import camilo from '../sounds/camilo.mp3';
import React from 'react';
import * as style from './MusicPlayer.module.css';

const MusicPlayer = () => {
    const [play, { stop, pause }] = useSound(camilo);
    const [isPlaying, setIsPlaying] = React.useState(false);
    const playIcon = <i className={`fa-solid fa-play ${style.musicIcons}`}></i>;
    const pauseIcon = <i className={`fa-solid fa-pause ${style.musicIcons}`}></i>;

    const musicStateChange = () => {
        if (isPlaying) {
            pause();
            setIsPlaying(false);
        } else {
            playSong();
            setIsPlaying(true);
        }
    };

    const playSong = () => {
        play();
        setIsPlaying(true);
    };

    return (
        <div className={style.marginTop}>
            <button className={style.startMusicButton} onClick={() => musicStateChange()}>
                <i className="fas fa-music"></i>
                <label>Toca aquí para reproducir la música</label>
            </button>
            <div className={style.musicPlayer}>
                <button onClick={() => musicStateChange()}>
                    {isPlaying ? pauseIcon : playIcon}
                </button>
            </div>
        </div>
    );
};

export default MusicPlayer;